import actions from './actions';
const initState = {
  user:null,
  tickets:[],
  report:null,
  tab:null,
  notifications:[],
}
export default function telepaseReducer(state=initState, action){
  switch (action.type) {
    case actions.CLEAR_ALL:
      return { state:initState };
    case actions.SEARCH_USER:
      return { ...state};

    case actions.SAVE_USER:
      return {...state, user:action.payload};

    case actions.SET_REPORT:
      return {...state, report:action.payload};

    case actions.SET_TAB:
      return {...state, tab:action.payload};

    case actions.SEARCH_TICKETS:
      return {...state, loading_tickets:true};

    case actions.SEARCH_TICKETS:
      return {...state};

    case actions.SAVE_TICKETS:
      return {...state, tickets:action.payload};

    case actions.SET_NOTIFICATIONS:
      return {...state, notifications:action.payload};

    default:
      return state
  }
}
